import * as Sentry from '@sentry/react'
import { Navigate, useRevalidator, useRouteError } from 'react-router'

import {
  FeedbackNetworkError,
  FeedbackUnknownError,
} from '@/components/feedbacks'
import { MissingResourceIdInRouteError } from '@/errors/route/missing-resource-id'
import { getSentryEventId } from '@/queries/utils/sentry-events-id'
import { NetworkError } from '@/services/fintalk/api/types/errors/NetworkError'

export function UserLoaderErrorElement() {
  const error = useRouteError()
  const revalidator = useRevalidator()

  const isMissingResourceIdError =
    error instanceof MissingResourceIdInRouteError

  if (isMissingResourceIdError) {
    Sentry.captureException(error)
    return <Navigate to="/companies" replace />
  }

  // TODO: Shows specific error component and message for user inactive (not found) error.

  const Feedback =
    error instanceof NetworkError ? FeedbackNetworkError : FeedbackUnknownError

  return (
    <div className="flex min-h-screen w-full items-center justify-center">
      <Feedback
        eventId={getSentryEventId(error)}
        onRetry={() => revalidator.revalidate()}
        isRetrying={revalidator.state === 'loading'}
      />
    </div>
  )
}
